import React from 'react'

import * as Yup from 'yup'
import { Form, Input, Select, Checkbox } from 'formik-antd'
import { BasicForm } from '../../../../core/components/form'
import { usePutForm, useFetch } from '../../../../hooks/admin/manager'
import { useHistory, useParams } from 'react-router-dom'
import Loader from '../../../../components/loader'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

import { MANAGER_GROUPS } from '../../../../config/const'

const LoginSchema = Yup.object().shape({
  first_name: Yup.string().required('Fisrt Name cannot be blank.'),
  last_name: Yup.string().required('Last Name cannot be blank.'),
  email: Yup.string().required('EMail cannot be blank.'),
  groups: Yup.array().min(1, 'Cannot be blank').required('Cannot be blank').nullable('Cannot be blank')
})

const Formulario = () => {
  const { id } = useParams()
  const { data, isLoading, isError } = useFetch(id)
  const update = usePutForm(id)
  const history = useHistory()

  function handleSubmit (values, bag) {
    const form = { ...values }

    update.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const onPressBack = () => history.goBack()

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  const initialValues = {
    first_name: data.manager.first_name,
    last_name: data.manager.last_name,
    phone: data.manager.phone,
    email: data.manager.email,
    skype: data.manager.skype,
    groups: data.manager.groups,
    can_log_in: data.manager.can_log_in
  }

  const newUser = !data.manager.user

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='EDIT MANAGER'
      initialValues={initialValues}
      validationSchema={LoginSchema}
      onSubmit={handleSubmit}
      render={() => (
        <>
          <Form.Item label='Groups' name='groups' showValidateSuccess hasFeedback required>
            <Select
              name='groups'
              style={{ width: '100%' }}
              placeholder='Manager Groups'
              options={MANAGER_GROUPS}
              mode='multiple'
            />
          </Form.Item>
          <Form.Item name='first_name' label='First Name' required>
            <Input name='first_name' />
          </Form.Item>
          <Form.Item name='last_name' label='Last Name' required>
            <Input name='last_name' />
          </Form.Item>
          <Form.Item label='Phone' name='phone'>
            <Input name='phone' placeholder='Phone' />
          </Form.Item>
          <Form.Item label='Email' name='email' required>
            <Input name='email' placeholder='Email' />
          </Form.Item>
          <Form.Item label='Skype' name='skype'>
            <Input name='skype' placeholder='Skype' />
          </Form.Item>
          <Form.Item
            label='Can log in'
            name='can_log_in'
            hasFeedback
            extra={newUser && 'If checked, the system will send an invitation email.'}
          >
            <Checkbox name='can_log_in' />
          </Form.Item>
        </>
      )}
    />
  )
}

export default Formulario
